"use strict";
// MIT License
//
// Copyright (c) 2023 Douglas Nassif Roma Junior
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const AnimationProvider_1 = __importDefault(require("./AnimationProvider"));
const GradientShimmer_1 = __importStar(require("./GradientShimmer"));
const isShimmerContainer = (item) => {
    return 'content' in item;
};
const ShimmerLayout = ({ testID, layout, defaultShimmerProps, ...shimmerProps }) => {
    const renderShimmerItem = (item, index) => {
        if (isShimmerContainer(item)) {
            return (react_1.default.createElement(ShimmerLayout, { ...shimmerProps, defaultShimmerProps: defaultShimmerProps, key: index, layout: item }));
        }
        return (react_1.default.createElement(GradientShimmer_1.default, { ...shimmerProps, ...defaultShimmerProps, key: index, width: item.width || defaultShimmerProps?.width, height: item.height || defaultShimmerProps?.height, style: [
                defaultShimmerProps?.style,
                typeof item.marginTop === 'number'
                    ? { marginTop: item.marginTop }
                    : null,
                typeof item.marginLeft === 'number'
                    ? { marginLeft: item.marginLeft }
                    : null,
                typeof item.marginRight === 'number'
                    ? { marginRight: item.marginRight }
                    : null,
                typeof item.marginBottom === 'number'
                    ? { marginBottom: item.marginBottom }
                    : null,
                item.style,
            ] }));
    };
    return (react_1.default.createElement(react_native_1.View, { testID: testID, style: [
            {
                flexDirection: layout.flexDirection,
                alignItems: layout.alignItems,
                justifyContent: layout.justifyContent,
                marginTop: layout.marginTop,
                marginBottom: layout.marginBottom,
                marginLeft: layout.marginLeft,
                marginRight: layout.marginRight,
                gap: layout.gap,
                columnGap: layout.columnGap,
                rowGap: layout.rowGap,
            },
            layout.style,
        ] }, layout.content.map(renderShimmerItem)));
};
const ShimmerLayoutWithProvider = (props) => {
    return (react_1.default.createElement(AnimationProvider_1.default, { animating: props.animating },
        react_1.default.createElement(ShimmerLayout, { ...props })));
};
ShimmerLayoutWithProvider.defaultProps = {
    visible: true,
    duration: GradientShimmer_1.gradientShimmerDefaultProps.duration,
    highlightWidth: GradientShimmer_1.gradientShimmerDefaultProps.highlightWidth,
    highlightColor: GradientShimmer_1.gradientShimmerDefaultProps.highlightColor,
    backgroundColor: GradientShimmer_1.gradientShimmerDefaultProps.backgroundColor,
    animating: GradientShimmer_1.gradientShimmerDefaultProps.animating,
    easing: GradientShimmer_1.gradientShimmerDefaultProps.easing,
};
exports.default = (0, react_1.memo)(ShimmerLayoutWithProvider);
//# sourceMappingURL=ShimmerLayout.js.map